export interface StyleCollection {
  id: string;
  name: string;
  style: string;
  coverImage: string;
  templateCount: number;
  generateCount: number;
  enabled: boolean;
  description: string;
  tags: string[];
}

export interface OutfitTypeTag {
  id: string;
  code: string;
  name: string;
  enabled?: boolean;
  groupCode?: string;
  groupId?: string;
}

export interface SupplementalImage {
  id: string;
  imageUrl: string;
  sortOrder: number;
}

export interface StyleTemplate {
  id: string;
  name: string;
  styleId: string;
  styleName: string;
  subcategory?: string;
  subsubcategory?: string;
  image: string;
  enabled: boolean;
  generateCount: number;
  todayCount: number;
  complianceStatus: "approved" | "pending";
  description: string;
  style?: "chibi" | "photo" | string;
  scene?: string;
  prompt?: string;
  generationProvider?: "wan" | "facefusion";
  outfitType?: OutfitTypeTag | null;
  supplementalImages?: SupplementalImage[];
}

export interface PureSwapTemplate {
  id: string;
  name: string;
  sceneType: string;
  image: string;
  enabled: boolean;
  generateCount: number;
  todayCount: number;
  complianceStatus: "approved" | "pending";
  description: string;
  facePosition: "center" | "left" | "right";
}

export const augcStats = {
  totalTemplates: 82,
  enabledTemplates: 74,
  todayGenerated: 342,
  totalStyles: 6,
  totalPureScenes: 36,
};

export const styleCollections: StyleCollection[] = [
  {
    id: "qban",
    name: "Q版萌系",
    style: "qban",
    coverImage: "/assets/img/1e64e0f606232d9d.jpg",
    templateCount: 12,
    generateCount: 8421,
    enabled: true,
    description: "Q版卡通风格，头大身小，萌趣可爱",
    tags: ["卡通", "Q版", "萌系"],
  },
  {
    id: "realistic",
    name: "写实风格",
    style: "realistic",
    coverImage: "/assets/img/0c2919d9815ed355.jpg",
    templateCount: 16,
    generateCount: 12543,
    enabled: true,
    description: "真实照片级质感，光影自然细腻",
    tags: ["写实", "摄影", "高清"],
  },
  {
    id: "cartoon",
    name: "卡通插画",
    style: "cartoon",
    coverImage: "/assets/img/439f365bce37c53e.jpg",
    templateCount: 10,
    generateCount: 5621,
    enabled: true,
    description: "色彩鲜明，线条简洁，活泼有趣",
    tags: ["卡通", "插画", "扁平"],
  },
  {
    id: "ink",
    name: "水墨国风",
    style: "ink",
    coverImage: "/assets/img/e1a4668f4d8c02bf.jpg",
    templateCount: 8,
    generateCount: 3421,
    enabled: true,
    description: "传统水墨画风，意境悠远，东方美学",
    tags: ["水墨", "国风", "古典"],
  },
  {
    id: "oil",
    name: "油画质感",
    style: "oil",
    coverImage: "/assets/img/2465e383918a4289.jpg",
    templateCount: 10,
    generateCount: 2187,
    enabled: true,
    description: "油画笔触，厚涂质感，艺术收藏级",
    tags: ["油画", "艺术", "古典"],
  },
  {
    id: "pixel",
    name: "像素复古",
    style: "pixel",
    coverImage: "/assets/img/d4d1481a8e7aefb1.jpg",
    templateCount: 8,
    generateCount: 1290,
    enabled: false,
    description: "复古像素风格，游戏怀旧，经典8位",
    tags: ["像素", "复古", "游戏"],
  },
];

export const styleTemplates: StyleTemplate[] = [
  {
    id: "s1",
    name: "鲟侠船长",
    styleId: "qban",
    styleName: "Q版萌系",
    image: "/assets/img/30a43bae4c8083ce.jpg",
    enabled: true,
    generateCount: 4521,
    todayCount: 23,
    complianceStatus: "approved",
    description: "Q版鲟侠船长IP形象",
  },
  {
    id: "s2",
    name: "江豚守护",
    styleId: "qban",
    styleName: "Q版萌系",
    image: "/assets/img/c323a2fed324de6c.jpg",
    enabled: true,
    generateCount: 1876,
    todayCount: 12,
    complianceStatus: "approved",
    description: "Q版江豚守护者形象",
  },
  {
    id: "s3",
    name: "金梅导游",
    styleId: "qban",
    styleName: "Q版萌系",
    image: "/assets/img/d0593b3ba29c923d.jpg",
    enabled: true,
    generateCount: 980,
    todayCount: 8,
    complianceStatus: "approved",
    description: "Q版金梅导游IP形象",
  },
  {
    id: "s4",
    name: "大坝实景",
    styleId: "realistic",
    styleName: "写实风格",
    image: "/assets/img/a93423119db7726d.jpg",
    enabled: true,
    generateCount: 3892,
    todayCount: 45,
    complianceStatus: "approved",
    description: "写实风格大坝合影",
  },
  {
    id: "s5",
    name: "日出峰顶",
    styleId: "realistic",
    styleName: "写实风格",
    image: "/assets/img/340fe546c4f64e9c.jpg",
    enabled: true,
    generateCount: 3245,
    todayCount: 34,
    complianceStatus: "approved",
    description: "写实风格日出合影",
  },
  {
    id: "s6",
    name: "江边漫步",
    styleId: "realistic",
    styleName: "写实风格",
    image: "/assets/img/a11191bd013fc07f.jpg",
    enabled: true,
    generateCount: 2156,
    todayCount: 18,
    complianceStatus: "approved",
    description: "写实风格江边漫步",
  },
  {
    id: "s7",
    name: "游船卡通",
    styleId: "cartoon",
    styleName: "卡通插画",
    image: "/assets/img/f5b4e4ff0336d584.jpg",
    enabled: true,
    generateCount: 2156,
    todayCount: 18,
    complianceStatus: "approved",
    description: "卡通插画游船场景",
  },
  {
    id: "s8",
    name: "古风卡通",
    styleId: "cartoon",
    styleName: "卡通插画",
    image: "/assets/img/72ad9e00d0acbffe.jpg",
    enabled: true,
    generateCount: 1654,
    todayCount: 8,
    complianceStatus: "approved",
    description: "卡通插画古风人物",
  },
  {
    id: "s9",
    name: "水墨屈原",
    styleId: "ink",
    styleName: "水墨国风",
    image: "/assets/img/2296b94f429e00ce.jpg",
    enabled: true,
    generateCount: 1654,
    todayCount: 8,
    complianceStatus: "approved",
    description: "水墨风格屈原赋诗",
  },
  {
    id: "s10",
    name: "水墨神女",
    styleId: "ink",
    styleName: "水墨国风",
    image: "/assets/img/1f028505860876db.jpg",
    enabled: true,
    generateCount: 2890,
    todayCount: 16,
    complianceStatus: "pending",
    description: "水墨风格神女峰传说",
  },
  {
    id: "s11",
    name: "油画三峡",
    styleId: "oil",
    styleName: "油画质感",
    image: "/assets/img/b0f6a45ccf8e5659.jpg",
    enabled: true,
    generateCount: 2187,
    todayCount: 10,
    complianceStatus: "approved",
    description: "油画质感三峡风景",
  },
  {
    id: "s12",
    name: "像素游侠",
    styleId: "pixel",
    styleName: "像素复古",
    image: "/assets/img/ff4deb1bafd5bf0f.jpg",
    enabled: false,
    generateCount: 0,
    todayCount: 0,
    complianceStatus: "pending",
    description: "像素风格冒险角色",
  },
];

export const pureSwapTemplates: PureSwapTemplate[] = [
  {
    id: "p1",
    name: "三峡大坝全景",
    sceneType: "山水风景",
    image: "/assets/img/098587725c160c2c.jpg",
    enabled: true,
    generateCount: 4521,
    todayCount: 23,
    complianceStatus: "approved",
    description: "站在三峡大坝观景台，壮丽全景尽收眼底",
    facePosition: "center",
  },
  {
    id: "p2",
    name: "巫山神女峰",
    sceneType: "山水风景",
    image: "/assets/img/b8904a0db0036f09.jpg",
    enabled: true,
    generateCount: 3892,
    todayCount: 45,
    complianceStatus: "approved",
    description: "与巫山神女峰同框，云雾缭绕如仙境",
    facePosition: "center",
  },
  {
    id: "p3",
    name: "长江三峡游船",
    sceneType: "城市风光",
    image: "/assets/img/b37fbf31d34d13a0.jpg",
    enabled: true,
    generateCount: 2156,
    todayCount: 18,
    complianceStatus: "approved",
    description: "豪华游轮甲板，一览两岸雄奇",
    facePosition: "center",
  },
  {
    id: "p4",
    name: "白帝城晨曦",
    sceneType: "名胜古迹",
    image: "/assets/img/e896b166a5b06360.jpg",
    enabled: true,
    generateCount: 1876,
    todayCount: 12,
    complianceStatus: "approved",
    description: "白帝城晨曦中，感受千年历史",
    facePosition: "center",
  },
  {
    id: "p5",
    name: "三峡日出",
    sceneType: "日出日落",
    image: "/assets/img/efa6dfbb6c02b437.jpg",
    enabled: true,
    generateCount: 3245,
    todayCount: 34,
    complianceStatus: "approved",
    description: "日出时分，金色光芒洒满三峡",
    facePosition: "center",
  },
  {
    id: "p6",
    name: "瞿塘峡夔门",
    sceneType: "山水风景",
    image: "/assets/img/c23b1ec65742b30b.jpg",
    enabled: true,
    generateCount: 2890,
    todayCount: 16,
    complianceStatus: "pending",
    description: "夔门天下雄，雄奇壮美的自然奇观",
    facePosition: "center",
  },
  {
    id: "p7",
    name: "三峡夜景",
    sceneType: "城市风光",
    image: "/assets/img/0be33fc79ae417a0.jpg",
    enabled: true,
    generateCount: 1654,
    todayCount: 8,
    complianceStatus: "approved",
    description: "三峡夜景璀璨，流光溢彩",
    facePosition: "center",
  },
  {
    id: "p8",
    name: "屈原故里",
    sceneType: "名胜古迹",
    image: "/assets/img/5c8f1df68e75aa46.jpg",
    enabled: true,
    generateCount: 1421,
    todayCount: 6,
    complianceStatus: "approved",
    description: "屈原故里，寻访爱国诗人足迹",
    facePosition: "center",
  },
  {
    id: "p9",
    name: "三峡人家",
    sceneType: "山水风景",
    image: "/assets/img/a066b8168c0be467.jpg",
    enabled: true,
    generateCount: 2340,
    todayCount: 18,
    complianceStatus: "approved",
    description: "三峡人家古朴村落，依山傍水",
    facePosition: "center",
  },
  {
    id: "p10",
    name: "西陵峡",
    sceneType: "山水风景",
    image: "/assets/img/ae00cef4eb5b1997.jpg",
    enabled: true,
    generateCount: 1980,
    todayCount: 14,
    complianceStatus: "approved",
    description: "西陵峡险峻秀美，峡谷幽深",
    facePosition: "center",
  },
  {
    id: "p11",
    name: "宜昌长江大桥",
    sceneType: "城市风光",
    image: "/assets/img/e2d3566e09d8bf6b.jpg",
    enabled: true,
    generateCount: 1230,
    todayCount: 9,
    complianceStatus: "approved",
    description: "宜昌长江大桥，现代工程与自然交融",
    facePosition: "center",
  },
  {
    id: "p12",
    name: "张飞庙",
    sceneType: "名胜古迹",
    image: "/assets/img/302856e27f67620a.jpg",
    enabled: true,
    generateCount: 1560,
    todayCount: 11,
    complianceStatus: "approved",
    description: "张飞庙古朴庄严，三国文化遗迹",
    facePosition: "center",
  },
  {
    id: "p13",
    name: "三峡日落",
    sceneType: "日出日落",
    image: "/assets/img/7fc98e416ba9dede.jpg",
    enabled: true,
    generateCount: 2870,
    todayCount: 22,
    complianceStatus: "approved",
    description: "三峡日落晚霞满天，壮美如画",
    facePosition: "center",
  },
  {
    id: "p14",
    name: "三峡瀑布",
    sceneType: "山水风景",
    image: "/assets/img/6dbcef007d2e4117.jpg",
    enabled: true,
    generateCount: 1890,
    todayCount: 13,
    complianceStatus: "approved",
    description: "三峡瀑布飞流直下，彩虹映水",
    facePosition: "center",
  },
  {
    id: "p15",
    name: "神女峰日出",
    sceneType: "日出日落",
    image: "/assets/img/d4e45d1e22c202cd.jpg",
    enabled: true,
    generateCount: 2100,
    todayCount: 16,
    complianceStatus: "pending",
    description: "神女峰日出金光万丈，神话传说之地",
    facePosition: "center",
  },
  {
    id: "p16",
    name: "丰都鬼城",
    sceneType: "名胜古迹",
    image: "/assets/img/e3ae239625a0a03e.jpg",
    enabled: true,
    generateCount: 1450,
    todayCount: 8,
    complianceStatus: "approved",
    description: "丰都鬼城神秘莫测，民间传说之旅",
    facePosition: "center",
  },
  {
    id: "p17",
    name: "三峡大坝夜景",
    sceneType: "城市风光",
    image: "/assets/img/843186340aaa5c8c.jpg",
    enabled: true,
    generateCount: 1780,
    todayCount: 12,
    complianceStatus: "approved",
    description: "三峡大坝夜景灯火辉煌，流光溢彩",
    facePosition: "center",
  },
  {
    id: "p18",
    name: "昭君故里",
    sceneType: "名胜古迹",
    image: "/assets/img/73caceecfd095c0b.jpg",
    enabled: true,
    generateCount: 1320,
    todayCount: 7,
    complianceStatus: "approved",
    description: "昭君故里，美人故乡的古典园林",
    facePosition: "center",
  },
];

export const sceneTypeLabels: Record<string, string> = {
  "山水风景": "山水风景",
  "城市风光": "城市风光",
  "日出日落": "日出日落",
  "名胜古迹": "名胜古迹",
};

export const sceneTypeColors: Record<string, string> = {
  "山水风景": "bg-emerald-50 text-emerald-700",
  "城市风光": "bg-sky-50 text-sky-700",
  "日出日落": "bg-amber-50 text-amber-700",
  "名胜古迹": "bg-rose-50 text-rose-700",
};

export const styleLabels: Record<string, string> = {
  qban: "Q版萌系",
  realistic: "写实风格",
  cartoon: "卡通插画",
  ink: "水墨国风",
  oil: "油画质感",
  pixel: "像素复古",
};

export const styleColors: Record<string, string> = {
  qban: "bg-pink-50 text-pink-700",
  realistic: "bg-amber-50 text-amber-700",
  cartoon: "bg-violet-50 text-violet-700",
  ink: "bg-gray-50 text-gray-700",
  oil: "bg-orange-50 text-orange-700",
  pixel: "bg-green-50 text-green-700",
};

export const getStyleColor = (styleId: string) => styleColors[styleId] || "bg-gray-50 text-gray-700";
export const getStyleLabel = (styleId: string) => styleLabels[styleId] || "未知风格";
export const getSceneTypeColor = (sceneType: string) => sceneTypeColors[sceneType] || "bg-gray-50 text-gray-700";
export const getSceneTypeLabel = (sceneType: string) => sceneTypeLabels[sceneType] || sceneType;

export const styleRankData = [
  { name: "写实风格", value: 12543 },
  { name: "Q版萌系", value: 8421 },
  { name: "卡通插画", value: 5621 },
  { name: "水墨国风", value: 3421 },
  { name: "油画质感", value: 2187 },
  { name: "像素复古", value: 1290 },
];

export const styleRankDataToday = [
  { name: "写实风格", value: 420 },
  { name: "Q版萌系", value: 280 },
  { name: "卡通插画", value: 190 },
  { name: "水墨国风", value: 120 },
  { name: "油画质感", value: 80 },
  { name: "像素复古", value: 45 },
];

export const styleRankData7d = [
  { name: "写实风格", value: 3200 },
  { name: "Q版萌系", value: 2150 },
  { name: "卡通插画", value: 1400 },
  { name: "水墨国风", value: 890 },
  { name: "油画质感", value: 560 },
  { name: "像素复古", value: 340 },
];

export const styleRankData30d = [
  { name: "写实风格", value: 12543 },
  { name: "Q版萌系", value: 8421 },
  { name: "卡通插画", value: 5621 },
  { name: "水墨国风", value: 3421 },
  { name: "油画质感", value: 2187 },
  { name: "像素复古", value: 1290 },
];

export const sceneHeatData = [
  { name: "山水风景", value: 11304 },
  { name: "城市风光", value: 3810 },
  { name: "日出日落", value: 3245 },
  { name: "名胜古迹", value: 3297 },
];

export const sceneHeatDataToday = [
  { name: "山水风景", value: 180 },
  { name: "城市风光", value: 65 },
  { name: "日出日落", value: 52 },
  { name: "名胜古迹", value: 58 },
];

export const sceneHeatData7d = [
  { name: "山水风景", value: 2800 },
  { name: "城市风光", value: 950 },
  { name: "日出日落", value: 810 },
  { name: "名胜古迹", value: 820 },
];

export const sceneHeatData30d = [
  { name: "山水风景", value: 11304 },
  { name: "城市风光", value: 3810 },
  { name: "日出日落", value: 3245 },
  { name: "名胜古迹", value: 3297 },
];

export const dailyTrendData = [
  { hour: "00", value: 5 },
  { hour: "01", value: 3 },
  { hour: "02", value: 2 },
  { hour: "03", value: 1 },
  { hour: "04", value: 1 },
  { hour: "05", value: 4 },
  { hour: "06", value: 12 },
  { hour: "07", value: 28 },
  { hour: "08", value: 45 },
  { hour: "09", value: 62 },
  { hour: "10", value: 58 },
  { hour: "11", value: 51 },
  { hour: "12", value: 38 },
  { hour: "13", value: 42 },
  { hour: "14", value: 55 },
  { hour: "15", value: 48 },
  { hour: "16", value: 36 },
  { hour: "17", value: 29 },
  { hour: "18", value: 22 },
  { hour: "19", value: 18 },
  { hour: "20", value: 15 },
  { hour: "21", value: 12 },
  { hour: "22", value: 8 },
  { hour: "23", value: 6 },
];

export const dailyTrendDataToday = [
  { hour: "00", value: 5 },
  { hour: "01", value: 3 },
  { hour: "02", value: 2 },
  { hour: "03", value: 1 },
  { hour: "04", value: 1 },
  { hour: "05", value: 4 },
  { hour: "06", value: 12 },
  { hour: "07", value: 28 },
  { hour: "08", value: 45 },
  { hour: "09", value: 62 },
  { hour: "10", value: 58 },
  { hour: "11", value: 51 },
  { hour: "12", value: 38 },
  { hour: "13", value: 42 },
  { hour: "14", value: 55 },
  { hour: "15", value: 48 },
  { hour: "16", value: 36 },
  { hour: "17", value: 29 },
  { hour: "18", value: 22 },
  { hour: "19", value: 18 },
  { hour: "20", value: 15 },
  { hour: "21", value: 12 },
  { hour: "22", value: 8 },
  { hour: "23", value: 6 },
];

export const dailyTrendData7d = [
  { hour: "周一", value: 320 },
  { hour: "周二", value: 385 },
  { hour: "周三", value: 420 },
  { hour: "周四", value: 390 },
  { hour: "周五", value: 450 },
  { hour: "周六", value: 580 },
  { hour: "周日", value: 495 },
];

export const dailyTrendData30d = [
  { hour: "1日", value: 280 },
  { hour: "3日", value: 320 },
  { hour: "5日", value: 350 },
  { hour: "7日", value: 290 },
  { hour: "9日", value: 410 },
  { hour: "11日", value: 380 },
  { hour: "13日", value: 420 },
  { hour: "15日", value: 450 },
  { hour: "17日", value: 390 },
  { hour: "19日", value: 480 },
  { hour: "21日", value: 510 },
  { hour: "23日", value: 460 },
  { hour: "25日", value: 520 },
  { hour: "27日", value: 490 },
  { hour: "29日", value: 550 },
  { hour: "30日", value: 580 },
];

export const mockUserPhotos = [
  {
    id: "u1",
    name: "游客A",
    url: "/assets/img/c9359e2aba3df33e.jpg",
  },
  {
    id: "u2",
    name: "游客B",
    url: "/assets/img/46cf60ef88cc73e6.jpg",
  },
  {
    id: "u3",
    name: "游客C",
    url: "/assets/img/761841cf9d0772da.jpg",
  },
  {
    id: "u4",
    name: "游客D",
    url: "/assets/img/69ef46a3cc706f2b.jpg",
  },
];
